import React from "react";
import styles from "./UtilityBar.module.scss";
import { ButtonShape, ButtonSize } from "../../../enums/ButtonAttributesEnums";
import TNButton from "../../../reusable-components/TNButton";
import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import InputField from "../../../reusable-components/TNInputField";
import SearchIcon from "../../../assets/images/search-button.svg";
import FilterIcon from "../../../assets/images/filterIcon.svg";
import warningIcon from "../../../assets/images/warning-icon.svg";
import { TriggerType } from "../../../enums/TriggerTypeEnums";
import { utilityBarConsts } from "./constants";
import { useFormContext } from "react-hook-form";
import { Switch } from "antd";

interface UtilityBarProps {
  handleFilterDrawerOpen: () => void;
  handleSetSearchValue: (searchValue: string) => void;
  handleShowBlocked: () => void;
  filterCount: number;
  handleClearAllFilter: () => void;
  affectedJobCount?: number;
  isAffectedViewActive?: boolean;
  handleToggleAffectedView?: () => void;
}

const UtilityBar = ({
  handleFilterDrawerOpen,
  handleSetSearchValue,
  handleShowBlocked,
  filterCount,
  handleClearAllFilter,
  affectedJobCount = 0,
  isAffectedViewActive = false,
  handleToggleAffectedView,
}: UtilityBarProps) => {
  const { getValues, watch } = useFormContext();

  const addOnAfter = (
    <TNButton
      shape={ButtonShape.DEFAULT}
      size={ButtonSize.SMALL}
      block
      text={
        <img
          className={styles.searchFieldIcon}
          src={SearchIcon}
          alt={utilityBarConsts.SEARCH_ICON_ALT}
        />
      }
      onClick={() => {
        handleSetSearchValue(getValues(utilityBarConsts.SEARCH_FIELD_NAME));
      }}
    />
  );

  return (
    <>
      <div className={styles.headerSection}>
        <div className={styles.leftContainer}>
          <div className={styles.invoiceSearch}>
            <InputField
              type={InputfieldTypes.TEXT}
              name={utilityBarConsts.SEARCH_FIELD_NAME}
              placeholder={utilityBarConsts.SEARCH_PLACEHOLDER}
              addonAfter={addOnAfter}
              onKeyDown={(e) => {
                if (e.key === TriggerType.ENTER) {
                  e.preventDefault();
                  handleSetSearchValue(
                    getValues(utilityBarConsts.SEARCH_FIELD_NAME),
                  );
                }
              }}
            />
          </div>
          <TNButton
            filterButton
            badgeCount={filterCount}
            shape={ButtonShape.DEFAULT}
            size={ButtonSize.LARGE}
            text="Filter"
            afterTitle
            icon={<img src={FilterIcon} />}
            onClick={handleFilterDrawerOpen}
          />
          {filterCount > 0 && (
            <TNButton
              clearFilterButton
              shape={ButtonShape.ROUND}
              size={ButtonSize.MEDIUM}
              text="Clear All"
              onClick={handleClearAllFilter}
            />
          )}{" "}
        </div>
        <div className={styles.blockedToggle}>
          {!isAffectedViewActive && (
            <>
              <span>{utilityBarConsts.SHOW_BLOCKED}</span>
              <InputField
                name={utilityBarConsts.BLOCK_TOGGLE_NAME}
                type={InputfieldTypes.SWITCH}
                value={watch(utilityBarConsts.BLOCK_TOGGLE_NAME)}
                defaultChecked={watch(utilityBarConsts.BLOCK_TOGGLE_NAME)}
                onChange={handleShowBlocked}
              />
            </>
          )}
          {(affectedJobCount > 0 || isAffectedViewActive) && (
            <TNButton
              materialPriceErrorButton
              shape={ButtonShape.ROUND}
              size={ButtonSize.MEDIUM}
              icon={<img src={warningIcon} />}
              text={`Material Price Error (${affectedJobCount})`}
              onClick={handleToggleAffectedView}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default UtilityBar;
